"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * JNext Reward API for client FE
 * Reward API
 *
 * The version of the OpenAPI document: 0.0.1-SNAPSHOT
 * Contact: cons.pompili@jakala.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.OrderTrackingStatusEnum = void 0;
/**
 * ### Order tracking status values:   * `NOT_APPROVED` - Order not approved yet  * `APPROVED` - Order approved  * `ISSUE` - There is an issue for this order  * `SENT` - The order has been sent  * `DELIVERED` - The order has been delivered  * `ANNULLED` - The order has been annulled  * `DELETED` - The order has been deleted
 * @export
 * @enum {string}
 */
var OrderTrackingStatusEnum;
(function (OrderTrackingStatusEnum) {
    OrderTrackingStatusEnum["Inserted"] = "INSERTED";
    OrderTrackingStatusEnum["NotApproved"] = "NOT_APPROVED";
    OrderTrackingStatusEnum["Approved"] = "APPROVED";
    OrderTrackingStatusEnum["Issue"] = "ISSUE";
    OrderTrackingStatusEnum["Sent"] = "SENT";
    OrderTrackingStatusEnum["Delivered"] = "DELIVERED";
    OrderTrackingStatusEnum["Annulled"] = "ANNULLED";
    OrderTrackingStatusEnum["Deleted"] = "DELETED";
    OrderTrackingStatusEnum["Expired"] = "EXPIRED";
})(OrderTrackingStatusEnum = exports.OrderTrackingStatusEnum || (exports.OrderTrackingStatusEnum = {}));
